import { AttachmentSaveLocationVoModel } from '@well/attachment/domain';

export class InvoiceAttachmentSaveLocationVoModel extends AttachmentSaveLocationVoModel{

  issueDate: string | null = null;
  invoiceGenerationType: string | null = null;

}
